import FieldReferenceIdAndKeyDto from "../../../dtos/FieldReferenceIdAndKeyDto";
import PathAIMappingCapabilitiesDto from "../../../dtos/pathaimodule/PathAIMappingCapabilitiesDto";
import TransformationCapabilitiesDto from "../../../dtos/transformationmodule/TransformationCapabilitiesDto";

class GetPathAICapabilitiesResult {
    SourceFields: FieldReferenceIdAndKeyDto[];
    MappingsCapabilities: PathAIMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[]; 

    constructor(sourceFields: FieldReferenceIdAndKeyDto[], mappingsCapabilities: PathAIMappingCapabilitiesDto[], transformationCapabilities: TransformationCapabilitiesDto[]) {
        this.SourceFields = sourceFields;
        this.MappingsCapabilities = mappingsCapabilities;
        this.TransformationsCapabilities = transformationCapabilities;
    }
}

export default GetPathAICapabilitiesResult;
